
const dealerDataReducer = (state = '', action) => {
    switch (action.type) {
        
        case "GET_DEALER_DATA": 
			return {
				...state,
				data: action.payload,
			}; 
		default:
            return state
    }
}

export default dealerDataReducer;